import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["href"]
const _hoisted_2 = ["href"]
const _hoisted_3 = { class: "button-wrapper" }
const _hoisted_4 = {
  class: "btn-group",
  role: "group"
}

import {computed, onMounted, ref} from "vue";
import {BTableColumn} from "./BTable/BTable.types";
import {SystemAlerts, ConfirmModal} from "./Misc";
import BGrid from "./BGrid/BGrid.vue";

import {BButton} from "./BButton";
import DropDown from "@/components/Misc/DropDown.vue";
import {saveFile} from "@/composable/filesHelper";
import {storeToRefs} from "pinia";
import {useAgencyStore} from "@/stores/agencyStore";
import hasPermission from "@/composable/permissionHelper";


export default /*@__PURE__*/_defineComponent({
  __name: 'Agencies',
  setup(__props) {

const agencyStore = useAgencyStore();
const {loading} = storeToRefs(agencyStore);

const canAdd = computed(() => {
    return hasPermission("AddAgency");
});
const columns = ref<BTableColumn[]>([
    {
        key: "ori",
        text: "ORI",
        sortable: true,
        columnClass: ["align-middle"],
        class: (item) => ["text-nowrap"],
        value: (item) => item.ori,
    },

    {
        key: "agencyName",
        text: "Agency Name",
        sortable: true,
        columnClass: ["align-middle"],
        class: (item) => ["text-nowrap"],

        value: (item) => item.oriName,
    },
    {
        key: "agencyType",
        text: "Agency Type",
        sortable: false,
        columnClass: ["align-middle"],

        class: (item) => ["text-nowrap"],
        value: (item) => item.agencyType,
    },
    {
        key: "county",
        text: "County",
        sortable: false,
        columnClass: ["align-middle"],

        class: (item) => ["text-nowrap"],
        value: (item) => item.countyName,
    },
    {
        key: "dataCollection",
        text: "Active Data Collections",
        sortable: false,
        columnClass: ["align-top", "text-center"],
        class: (item) => ["text-nowrap"],
        value: (item) => item.dataCollectionStatus,
        children: [
            {
                key: "label",
                text: "Label",
                sortable: false,
                columnClass: ["align-top"],
                class: (subitem) => ["text-nowrap"],
                subRowValue: (_, row) => row.label,
            },
            {
                key: "startDate",
                text: "Start Date",
                sortable: false,
                columnClass: ["align-top"],
                class: (subitem) => ["text-nowrap"],
                subRowValue: (_, row) => row.startDate,
            },
            {
                key: "vendorName",
                text: "Vendor Name",
                sortable: false,
                columnClass: ["align-top"],
                class: (subitem) => ["text-nowrap"],
                subRowValue: (_, row) => row.vendorName,
            },
        ],
    },
]);

const canEdit = computed(() => {
    return true;
});

const exportData = async (type: string) => {
    let blob = await agencyStore.exportFile(type);
    saveFile(`agencies.${type}`, blob);
};

const getData = async () => {
    await agencyStore.list();
};

onMounted(async () => {
    await getData();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(BGrid, {
      caption: "Agencies",
      tableOptions: _unref(agencyStore).tableOptions,
      filterableFields: _unref(agencyStore).filterableFields,
      filterOptions: _unref(agencyStore).filterOptions,
      onOptionChange: getData,
      items: _unref(agencyStore).items,
      columns: columns.value,
      loading: _unref(loading)
    }, {
      beforeFilter: _withCtx(() => [
        (canAdd.value)
          ? (_openBlock(), _createBlock(_unref(BButton), {
              key: 0,
              to: "AgencyDetails.aspx"
            }, {
              default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                _createTextVNode("Add a new agency", -1)
              ]))]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      "cell.ori": _withCtx(({item}) => [
        _createElementVNode("a", {
          href: `AgencyDetails.aspx?id=${item.ori}`
        }, _toDisplayString(item.ori), 9, _hoisted_1)
      ]),
      "cell.agencyName": _withCtx(({item}) => [
        _createElementVNode("a", {
          href: `AgencyDetails.aspx?id=${item.ori}`
        }, _toDisplayString(item.oriName), 9, _hoisted_2)
      ]),
      "cell.actions": _withCtx(({item}) => [
        _createElementVNode("div", _hoisted_3, [
          (canEdit.value)
            ? (_openBlock(), _createBlock(_unref(BButton), {
                key: 0,
                to: `AgencyDetails.aspx?id=${item.ori}`,
                size: "sm"
              }, {
                default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                  _createTextVNode(" Edit ", -1)
                ]))]),
                _: 1
              }, 8, ["to"]))
            : _createCommentVNode("", true)
        ])
      ]),
      pagingStart: _withCtx(() => [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(DropDown, {
            label: "Export Data",
            "item-count": 2,
            "is-primary-button": true
          }, {
            item1: _withCtx(({item}) => [
              _createElementVNode("button", {
                class: "dropdown-item",
                onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (exportData('csv')), ["prevent"]))
              }, " Download as .csv ")
            ]),
            item2: _withCtx(({item}) => [
              _createElementVNode("button", {
                class: "dropdown-item",
                onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (exportData('xlsx')), ["prevent"]))
              }, " Download as .xlsx ")
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["tableOptions", "filterableFields", "filterOptions", "items", "columns", "loading"]),
    _createVNode(_unref(SystemAlerts)),
    _createVNode(_unref(ConfirmModal))
  ], 64))
}
}

})